import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import { ICategory } from "./api/models";
import { SetState } from "shared/types/general";
import { GetBonusesCategoriesApi } from "./api";

interface CategoriesProps {
  activeCategory: ICategory;
  setActiveCategory: SetState<ICategory>;
}

export const allCategory: ICategory = {
  active: 1,
  cnt: 1,
  created: "",
  id: 0,
  image: "",
  pinned: 0,
  priority: 1,
  title: "Все",
};

const Categories: React.FC<CategoriesProps> = ({
  activeCategory,
  setActiveCategory,
}) => {
  const [categoriesList, setCategoriesList] = useState<ICategory[]>([]);

  const handleChange = (item: ICategory) => {
    setActiveCategory(item);
  };

  useEffect(() => {
    GetBonusesCategoriesApi().then((res) => {
      setCategoriesList([allCategory, ...res]);
    });
  }, []);

  return (
    <ul className={s.categories}>
      {categoriesList.map((item) => (
        <li
          key={item.id}
          className={`${s.item} ${
            activeCategory?.id === item.id ? s.active : ""
          }`}
          onClick={() => handleChange(item)}
        >
          {item.title}
        </li>
      ))}
    </ul>
  );
};

export default Categories;
